import { Pipe, PipeTransform } from '@angular/core';
import {Serializer, Serializers} from '../../../../shared/interfaces/serializer';
import {SavedReport} from '../../../../shared/interfaces/saved-reports';
import {DataExporterUsage} from '../../../../shared/interfaces/data-exporter-usage';

@Pipe({
  name: 'filterReports'
})
export class FilterReportsPipe implements PipeTransform {

  transform(reports: Serializers<SavedReport>, exporterUsage: Serializer<DataExporterUsage>): Serializers<SavedReport> {
    if (exporterUsage) {
      if (exporterUsage.relationships.data_exporter.data.attributes.slug === 'email') {
        return reports;
      }

      return reports.filter((report: Serializer<SavedReport>): boolean => !['dashboard', 'chart', 'affinity'].includes(report.attributes.report_type));
    }

    return [];
  }

}
